import { Button } from '@mui/material';
import { Item } from './item-types';

interface ItemShareButtonProps {
  item: Item;
  onClick?: () => void;
}

export default function ItemShareButton({
  item,
  onClick,
}: ItemShareButtonProps) {
  return (
    <>
      <Button variant='contained' onClick={onClick}>
        Share Item
      </Button>
    </>
  );
}
